import ApiService from '../api.services';

const TagsGenerateService = {
  generate: async function (params) {
    try {
      const res = await ApiService.post(`/api/tags.generate`, params);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
};

export default TagsGenerateService;

export { TagsGenerateService };

